/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SpecialEquipmentType } from './specialEquipmentType';

/**
 * (german: Sonderausstattung)   (bipro-fahrzeug::Sonderausstattung)
 */
export interface SpecialEquipment {
  specialEquipmentType?: SpecialEquipmentType;
}
export namespace SpecialEquipment {}
